import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AddResult } from "../../Reducer/StaffSlice"

function ResultStaff(){
    const HoursStaffKashierArray = useSelector(state => state.StaffSlice.HoursStaffKashierArray)
    const HoursStaffCookArray = useSelector(state => state.StaffSlice.HoursStaffCookArray)
    const HoursStaffCookSecondGroupArray = useSelector(state => state.StaffSlice.HoursStaffCookSecondGroupArray)
    const StaffSelectedCityArray = useSelector(state => state.StaffSlice.StaffSelectedCityArray)

    const ResultKashier = useSelector(state => state.StaffSlice.ResultKashier)
    const ResultCook = useSelector(state => state.StaffSlice.ResultCook)
    const ResultCookSecondGroup = useSelector(state => state.StaffSlice.ResultCookSecondGroup)
    const ResultManager = useSelector(state => state.StaffSlice.ResultManager)
    const ResultOther = useSelector(state => state.StaffSlice.ResultOther)
    const ResultFOT = useSelector(state => state.StaffSlice.ResultFOT)

    const RevenueArray = useSelector(state => state.RevenueSlice.RevenueArray)
    const PercentCity = useSelector(state => state.RevenueSlice.PercentCity)

    const Period = useSelector(state => state.PeriodSlice.Period)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(AddResult({RevenueArray: RevenueArray, PercentCity: PercentCity, Period: Period}));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [StaffSelectedCityArray, HoursStaffKashierArray, HoursStaffCookSecondGroupArray, HoursStaffCookArray, RevenueArray, PercentCity, Period])

    const replaceData = (data) => {
        if (!data) return data;
        return String(data).replace('.', ',')
    }

    return(
        <div>

            {/*Касса*/}
            <div
            className="StaffPercentMainDiv Margin"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого касса руб.
                </div>
                }

                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultKashier.Result[el.id])}
                    </div>
                )}
                    
                    <div
                    className="DivFlex"
                    >                       
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                        {Period.MinDay < 14 && <div
                         className="RevenueTotalDiv"
                        >
                            {replaceData(ResultKashier.FirstTotalSum)}
                        </div>
                        }
                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        {Period.MaxDay > 15 &&
                        <div
                        className="RevenueCityLongDiv"
                        >
                        Итого касса руб.
                        </div>
                        }
                    </div>
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultKashier.Result[el.id])}
                    </div>
                )}

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultKashier.SecondTotalSum)}
                </div>
                }
                
                    
                

                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                

                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultKashier.TotalSum)}
                </div>
                }
            </div>

            {/*Повара 1 группа*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого повара (группа 1) руб.
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultCook.Result[el.id])}
                    </div>
                    )}
                    
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                             {replaceData(ResultCook.FirstTotalSum)}
                        </div>
                        }

                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        
                    </div>
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого повара (группа 1) руб.
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                         {replaceData(ResultCook.Result[el.id])}
                    </div>
                    )}
                
                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultCook.SecondTotalSum)}
                </div>
                }
                
                        

                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultCook.TotalSum)}
                </div>
                }
            </div>

            {/*Повара 2 группа*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого повара (группа 2) руб.
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultCookSecondGroup.Result[el.id])}
                    </div>
                    )}
                    
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                             {replaceData(ResultCookSecondGroup.FirstTotalSum)}
                        </div>
                        }

                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        
                    </div>
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого повара (группа 2) руб.
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                         {replaceData(ResultCookSecondGroup.Result[el.id])}
                    </div>
                    )}
                
                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultCookSecondGroup.SecondTotalSum)}
                </div>
                }

                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultCookSecondGroup.TotalSum)}
                </div>
                }
            </div>
                       
            {/*Управы*/}

            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого управление руб.
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > Period.MinDay && el.id < Period.MaxDay && el.id < 15 && 
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultManager.Result[el.id])}
                    </div>
                    )}
                    
                    <div
                    className="DivFlex"
                    >

                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {replaceData(ResultManager.FirstTotalSum)}                            
                        </div>
                        }

                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                        className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }     
                    </div>
                        
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого управление руб.
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultManager.Result[el.id])}
                    </div>
                    )}

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }
                 
                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                   {replaceData(ResultManager.SecondTotalSum)}
                </div>
                }
                
                        
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }               
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultManager.TotalSum)}
                </div>
                }
            </div>

           {/*Без %>*/}

           <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого кухрабочие и стажеры руб.
                </div>
                }

                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultOther.Result[el.id])}
                    </div>
                )}
                    <div
                    className="DivFlex"
                    >

                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }

                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {replaceData(ResultOther.FirstTotalSum)}                            
                        </div>
                        }                    

                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }                        

                    </div>
                        
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого кухрабочие и стажеры руб.
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultOther.Result[el.id])}                        
                    </div>
                )}

                {Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv"
                />
                }
                
                {Period.MaxDay > 15 &&
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultOther.SecondTotalSum)}
                </div>
                }                        

                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }

                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultOther.TotalSum)}
                </div>
                }
            </div>

            {/*Итого*/}
            <div
            className="StaffPercentMainDiv"
            >
                {Period.MinDay < 14 &&
                <div
                className="RevenueCityLongDiv"
                >
                Итого ФОТ руб.
                </div>
                }
                {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id < 15 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultFOT.Result[el.id])}
                    </div>
                )}
                    <div
                    className="DivFlex"
                    >
                        {Period.MinDay < 14 &&
                        <div
                        className="RevenueTotalDiv"
                        />
                        }
                        
                        {Period.MinDay < 14 &&
                        <div
                         className="RevenueTotalDiv"
                        >
                            {replaceData(ResultFOT.FirstTotalSum)}
                        </div>
                        }                    
                        
                        {Period.MinDay < 14 && Period.MaxDay > 15 && 
                        <div
                         className="RevenueMounthPartBetweenDiv ResultStaff"
                        />
                        }
                        
                    </div>
                    {Period.MaxDay > 15 &&
                    <div
                    className="RevenueCityLongDiv"
                    >
                    Итого ФОТ руб.
                    </div>
                    }
                    {RevenueArray.length > 0 && RevenueArray.map((el) => 
                    el.id > 14 && el.id > Period.MinDay && el.id < Period.MaxDay &&
                    <div
                    key={el.id}
                    className="DateDivRevenue"
                    >
                        {replaceData(ResultFOT.Result[el.id])}
                    </div>
                )}

                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                />
                }
                
                {Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultFOT.SecondTotalSum)}
                </div>
                }
                 
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueMounthPartBetweenDiv ResultStaff"
                />
                }
                
                {Period.MinDay < 14 && Period.MaxDay > 15 && 
                <div
                className="RevenueTotalDiv"
                >
                    {replaceData(ResultFOT.TotalSum)}
                </div>
                }
            </div>
                       
        </div>
    )
}

export default ResultStaff